import { TestWebinarBadge } from '@core/ui';

/**
 * The badge over the video (spec §5.6). The viewer and on-demand layouts render no title or
 * header, so this sits in the video's grid cell, top-left, above the player and below the
 * full-bleed overlays (which use z-50). Shared by the app and the embed, which render the same
 * organisms.
 */
export const TestWebinarOverlay = ({ isTest }: { isTest: boolean | undefined }) => {
    if (!isTest) return null;

    return (
        <div className="col-start-1 row-start-1 self-start justify-self-start z-10 p-2 pointer-events-none">
            <TestWebinarBadge />
        </div>
    );
};
